import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewExperimentVariant } = appStoreLenses

export default state => viewExperimentVariant(state)
